import { render, staticRenderFns } from "./CloseCircleIcon.vue?vue&type=template&id=228eedaf&"
import script from "./CloseCircleIcon.vue?vue&type=script&lang=ts&"
export * from "./CloseCircleIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports